<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Create New Shortlink</CCardHeader>

        <CCardBody>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="Destination URL"
                  class="mb-0 required"
                  :class="{ 'is-invalid': validate.destination_url.isInvalid }"
                  type="text"
                  required
                  horizontal
                  placeholder="https://masukkanlinkwebsiteanda.com"
                  :value="routesData.destination_url"
                  :description="validate.destination_url.message"
                  @input="handleTitle"
              />
            </CCol>
          </CRow>

          <!-- Shortlink -->
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="Shortlink"
                  class="mb-0 required"
                  :class="{ 'is-invalid': validate.slug.isInvalid }"
                  type="text"
                  required
                  horizontal
                  placeholder="Shortlink"
                  :value="routesData.slug"
                  :description="validate.slug.message || 'Shortlink hanya boleh berisi huruf kecil (a–z), angka (0–9), dan tanda hubung (-).'"
                  @input="handleSlug"
              >
                <template #append>
                  <button
                      class="px-3 py-1.5 rounded-md bg-gray-300 text-gray-800 hover:bg-gray-400 border-0"
                      @click="handleGenerateShortSlug"
                  >
                    Generate
                  </button>
                </template>
              </CInput>
            </CCol>
          </CRow>

          <!-- Status -->
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="Status"
                  :options="optionsActiveStatus"
                  required
                  class="required"
                  horizontal
                  placeholder="Pilih status"
                  :value="routesData.status"
                  :description="validate.status.message"
                  :class="{ 'is-invalid': validate.status.isInvalid }"
                  @change="handleStatus"
              />
            </CCol>
          </CRow>
        </CCardBody>

        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="$router.go(-1)">Back</CButton>
            </CCol>

            <CCol sm="7" class="d-none d-md-block">
              <CButton color="success" class="float-right" @click="handleSave">
                Save
              </CButton>
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import ShortlinkUseCase from "./app/usecase/index.js";
import RoutesUseCase from "@/views/modules/routes/app/usecase";

export default {
  name: "ProgramCreate",

  data() {
    return {
      showErrorField: false,

      routesData: {
        destination_url: "",
        slug: "",
        status: "active",
      },

      optionsActiveStatus: [
        { label: "ACTIVE", value: "active" },
        { label: "INACTIVE", value: "inactive" },
      ],
    };
  },

  computed: {
    validate() {
      const show = this.showErrorField;

      return {
        destination_url: {
          isInvalid: show && !this.routesData.destination_url,
          message: show && !this.routesData.destination_url ? "Description URL harus diisi" : ""
        },
        slug: {
          isInvalid: show && !this.routesData.slug,
          message: show && !this.routesData.slug ? "Shortlink harus diisi" : ""
        },
        status: {
          isInvalid: show && !this.routesData.status,
          message: show && !this.routesData.status ? "Status harus diisi" : ""
        }
      };
    },
  },

  methods: {
    generateShortlink(maxLength = 8) {
      const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
      const allChars = chars + "-";
      const length = Math.min(maxLength, 8);

      while (true) {
        let result = "";
        for (let i = 0; i < length; i++) {
          result += allChars.charAt(Math.floor(Math.random() * allChars.length));
        }
        if (result.startsWith("-") || result.endsWith("-")) continue;
        return result;
      }
    },

    handleTitle(e) {
      this.routesData.destination_url = e?.target?.value || e;
    },

    handleSlug(e) {
      this.routesData.slug = e?.target?.value || e;
    },

    handleStatus(e) {
      this.routesData.status = e?.target?.value || e;
    },

    handleGenerateShortSlug() {
      this.routesData.slug = this.generateShortlink();
    },

    handleSave() {
      this.showErrorField = true;

      if (this.validate.destination_url.isInvalid ||
          this.validate.slug.isInvalid ||
          this.validate.status.isInvalid) {

        const messages = [
          this.validate.destination_url.message,
          this.validate.slug.message,
          this.validate.status.message,
        ].filter(Boolean);

        this.$swal.fire({
          icon: "error",
          html: `
            <h3>Terjadi kesalahan</h3>
            <ul style="text-align:left;">
              ${messages.map((e) => `<li>${e}</li>`).join("")}
            </ul>`
        });
        return;
      }

      this.processSave();
    },
    async processSave() {
      await this.$swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: async () => {
          this.$swal.showLoading();
          try {
            const { err } = await ShortlinkUseCase.saveOne(
                this.generateFormData()
            );
            if (err) {
              this.$swal.close();
              await this.$swal.fire({
                icon: "error",
                text: err,
              });
            } else {
              this.$swal.close();
              await this.$swal.fire({
                icon: "success",
                text: "Shortlink saved",
              });
              this.$router.push({ path: `/management/shortlink` });
            }
          } catch (err) {
            this.$swal.close();
            await this.$swal.fire({
              icon: "error",
              text: err,
            });
          }
        },
      });
    },

    generateFormData() {
      return { ...this.routesData };
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Poppins&display=swap");
@import "./Shortlink.css";
</style>